import React, { useState } from 'react';

import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';

import { Paper, Stack, Tab, Tabs } from '@mui/material';

import { useGetSalesforceSurcharges } from '~/hooks/apis/reservations/useGetSalesforceSurcharges';

import SurchargesTab from './SurchargesTab';
import TabPlaceholder from './TabPlaceholder';
import { DEAL_INFORMATION_TABS } from './constants';
import type { DealInformationTab } from './types';

export default function OfferBuilderDealInformationPage() {
  const { id_offer: offerId } = useParams<{ id_offer: string }>();
  const [activeTab, setActiveTab] = useState<DealInformationTab>('details');
  const {
    data: salesforceSurcharges = [],
    isLoading: isLoadingSurcharges,
    error: surchargesError,
  } = useGetSalesforceSurcharges(activeTab === 'surcharges' ? (offerId ?? null) : null);

  return (
    <>
      <Helmet>
        <title>Deal Information | Offer Builder</title>
      </Helmet>

      <Stack spacing={3}>
        <Paper sx={{ position: 'sticky', top: 0, zIndex: 2 }}>
          <Tabs
            allowScrollButtonsMobile
            scrollButtons="auto"
            value={activeTab}
            variant="scrollable"
            onChange={(_event, value: DealInformationTab) => setActiveTab(value)}
          >
            {DEAL_INFORMATION_TABS.map((tab) => (
              <Tab key={tab.value} label={tab.label} value={tab.value} />
            ))}
          </Tabs>
        </Paper>

        {activeTab === 'surcharges' ? (
          <SurchargesTab error={surchargesError} isLoading={isLoadingSurcharges} surcharges={salesforceSurcharges} />
        ) : (
          <TabPlaceholder title={DEAL_INFORMATION_TABS.find((tab) => tab.value === activeTab)?.label ?? 'Details'} />
        )}
      </Stack>
    </>
  );
}
